<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <div class="field-container">
      <h3> {{'createUser.personalInformationForm.title'|translate}}</h3>
      <h5> {{'createUser.personalInformationForm.subtitle'|translate}}</h5>
    </div>

    <app-input-field [control]="formGroup.controls.firstName"
                     class="field-container"
                     [label]="'createUser.firstName'|translate">
      <input name="name"
             formControlName="firstName"
             class="input">
    </app-input-field>

    <app-input-field [control]="formGroup.controls.lastName"
                     class="field-container"
                     [label]="'createUser.lastName'|translate">
      <input name="name"
             formControlName="lastName"
             class="input">
    </app-input-field>
    <app-input-field [control]="formGroup.controls.email"
                     class="field-container"
                     [label]="'createUser.email'|translate">
      <input name="email"
             formControlName="email"
             class="input">
    </app-input-field>
  </div>
</form>
